import { z } from 'zod';
import type { Layout } from '@kioskforge/shared';
import type { PresetDefinition } from './types';

/**
 * A5b.8 — an optional colour threshold for the live tile. `colour` is a semantic
 * token name (`accent`, `danger`, …), never a colour literal — the style gate
 * enforces that, and the server maps this straight into
 * `live_tile.props.thresholds`.
 */
export const tileThresholdSchema = z.object({
  gte: z.number().optional(),
  lte: z.number().optional(),
  colour: z.string().min(1)
});

const config_schema = z.object({
  title: z.string().min(1),
  primary_data_key: z.string().min(1),
  unit: z.string().optional(),
  label: z.string().min(1).optional(),
  threshold: tileThresholdSchema.optional()
});
const layout = {
  version: 1 as const, grid: { cols: 4, rows: 4 }, home: 'dashboard',
  screens: [{ id: 'dashboard', name: 'Live dashboard', blocks: [
    { id: 'title', type: 'text' as const, rect: { x: 0, y: 0, w: 4, h: 1 }, props: { text: '{data.title}', size: 'lg' as const, align: 'center' as const, weight: 'bold' as const } },
    { id: 'visitors', type: 'live_tile' as const, rect: { x: 1, y: 1, w: 2, h: 3 }, props: { data_key: 'visitors', label: 'Visitors now', format: 'number' as const } }
  ] }]
} satisfies Layout;

export const dashboard: PresetDefinition<typeof config_schema> = {
  key: 'dashboard', sector: 'Dashboard & Control Panel', wave: 1, name: 'Live dashboard',
  min_lockdown: 'pwa', device_classes: ['tablet', 'esp32'], config_schema, layout
};